import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Agents from '../agent/Agents';
import Conversation from '../conversation/Conversations';
import Customers from '../customer/Customers';
import AgentPage from '../agent/AgentPage';
import './App.scss';
import ConversationPage from "../conversation/ConversationPage";
import CustomerPage from "../customer/CustomerPage";
import Header from "./header/Header";
import EntryPage from '../entry-page/EntryPage';
import IntegrationPage from "../integration/IntegrationPage";
import LoginPage from '../login/LoginPage';
import PrivateRoute from '../security/PrivateRoute';
import { useAuth } from '../security/AuthContext';
import NotificationPopup from "../notification/NotificationPopup";
import Integrations from "../integration/Integrations";
import Workflow from "../workflow/Workflows";
import WorkflowPage from "../workflow/WorkflowPage";
import Workflows from "../workflow/Workflows";

const Sidebar: React.FC = () => {
  const location = useLocation(); // Get the current location

  const isActive = (path: string) => location.pathname === path ? 'active' : '';

  return (
    <div className="sidebar">
      <ul>
        <li><Link to="/agents" className={isActive('/agents')}>AI Agent</Link></li>
        <li><Link to="/workflows" className={isActive('/workflows')}>Workflows</Link></li>
        <li><Link to="/customers" className={isActive('/customers')}>Customers</Link></li>
        <li><Link to="/conversations" className={isActive('/conversations')}>Conversation</Link></li>
        <li><Link to="/integrations" className={isActive('/integrations')}>Integration</Link></li>
      </ul>
    </div>
  );
};

const LOGIN_PATH = '/login';

export interface PageProps {
  showNotification: (message: string) => void;
}

const App: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [showPopup, setShowPopup] = useState(false); // State for managing popup visibility
  const [popupMessage, setPopupMessage] = useState<string>(''); // State for storing popup message

  useEffect(() => {
    if (!isAuthenticated && window.location.pathname !== LOGIN_PATH) {
      window.location.href = LOGIN_PATH; // Native browser redirect
    }
  }, [isAuthenticated]);

  const showNotification = (message: string) => {
    setPopupMessage(message);
    setShowPopup(true);
  };

  const hideNotification = () => {
    setShowPopup(false);
  };

  return (
    <Router>
      {isAuthenticated ? (
        <>
          <Header />
          <div style={{ display: 'flex' }}>
            <Sidebar />
            <div className="main-content">
              <Routes>
                <Route path="/" element={<PrivateRoute element={<EntryPage />} />} />
                <Route path="/agents" element={<PrivateRoute element={<Agents />} />} />
                <Route path="/agent/:uuid?" element={<PrivateRoute element={<AgentPage showNotification={showNotification} />} />} />
                <Route path="/conversations" element={<PrivateRoute element={<Conversation />} />} />
                <Route path="/conversation/:uuid?" element={<PrivateRoute element={<ConversationPage />} />} />
                <Route path="/customers" element={<PrivateRoute element={<Customers />} />} />
                <Route path="/customer/:uuid?" element={<PrivateRoute element={<CustomerPage />} />} />
                <Route path="/integrations" element={<PrivateRoute element={<Integrations />} />} />
                <Route path="/integration/:uuid?" element={<PrivateRoute element={<IntegrationPage showNotification={showNotification} />} />} />
                <Route path="/workflows" element={<PrivateRoute element={<Workflows />} />} />
                <Route path="/workflow/:uuid?" element={<PrivateRoute element={<WorkflowPage showNotification={showNotification} />} />} />
              </Routes>
            </div>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<LoginPage />} /> {/* Redirect to login page if not authenticated */}
        </Routes>
      )}

      {/* Notification popup is shown globally here */}
      <NotificationPopup
        message={popupMessage}
        visible={showPopup}
        onClose={hideNotification}
      />
    </Router>
  );
};

export default App;
